import AuthPage from './AuthPage'
import LoadingScreen from '../../components/LoadingScreen'
import styled from 'styled-components'
import OktaButton from './OktaButton'
import { useOktaAuth } from '@okta/okta-react'

const LoginScreen: React.FC = () => {
  const { authState } = useOktaAuth()

  const AuthComponent = (
    <AuthPage title={'Sign In'}>
      <InputContainer>
        <p>Please sign in to continue.</p>
        <OktaButton text="Sign In with SSO" />
      </InputContainer>
    </AuthPage>
  )

  // Use Okta's pending state to show a loading screen while it checks the session
  if (authState?.isPending) {
    return <LoadingScreen />
  }
  return AuthComponent
}

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  text-align: center;
`

export default LoginScreen
export { InputContainer }
